import React, { FC } from 'react';
import { useKeyDown } from '@utils/hooks/useKeyboard';

import classnames from 'classnames/bind';
import styles from './backgroundArea.module.scss';
const cx = classnames.bind(styles);

interface IBackgroundAreaProps {
  visible: boolean;
  onClickArea: () => void;
}

const BackgroundArea: FC<IBackgroundAreaProps> = ({ visible, onClickArea }) => {
  useKeyDown(() => {
    if (visible) {
      onClickArea();
    }
  }, 'Escape');

  if (!visible) return null;

  return <div className={cx('bg')} onClick={onClickArea} />;
};

export default BackgroundArea;
